import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  packageGetUnitsOfMeasurement,
  packageGetImage,
  packageAddImage
} from "actions/package/actions";
import languages from "../../../data/languages";
import getFilesUrl from "../../../helpers/getFilesUrl";
import Translations from "./translations";

const languageTemplate = {
  description: "",
  language: "",
  name: "",
};

class EditModal extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);

    const { pack } = this.props;
    this.state = {
      id: pack ? pack.id : false,
      code: pack ? pack.code : "",
      active: pack ? pack.active : false,
      limited: pack ? pack.limited : false,
      popular: pack ? pack.popular : false,
      price: pack ? pack.price : 0,
      duration: pack ? pack.duration : 0,
      timeUnit: pack ? pack.timeUnit : 0, // todo
      minute: pack ? pack.minute : 0,
      translations: pack ? pack.translations : Object.keys(languages)
        .map(langKey => ({
          ...languageTemplate,
          language: langKey
        })),
      logo: pack ? pack.logo : {},

      previewImage: getFilesUrl(pack.logo),
      imageFile: null,
    };

    this.props.packageGetUnitsOfMeasurement();
    if (this.state.id) {
      this.props.packageGetImage(this.state.id);
    }
  }

  handleChangeImage = ev => {
    const file = ev.target.files[0];
    this.setState({
      previewImage: URL.createObjectURL(file),
      imageFile: file
    });
  };

  handleChangeLanguage = (lang, name, value) => {
    const translations = [...this.state.translations];

    const languageItemIndex = translations.findIndex(i => i.language === lang);
    const languageItem = (languageItemIndex === -1) ? { ...languageTemplate } : { ...translations[languageItemIndex] };

    languageItem.language = lang;
    languageItem[name] = value;

    this.setState({
      translations: [
        ...this.state.translations.filter(i => i.language !== lang),
        languageItem
      ]
    });
  };

  handleChangeForm = (ev) => {
    const {
      name,
      value
    } = ev.target;
    this.setState({
      [name]: value
    });
  };

  handleSubmit = () => {
    const data = Object.assign({}, this.state);
    if (!data.id) {
      delete data.id;
      delete data.imageFile;
      delete data.previewImage;
      delete data.logo;
    }
    this.props.onSubmit(data);
  };

  render() {
    const {
      unitsOfMeasurement,
    } = this.props;

    const {
      active,
      code,
      duration,
      // id, // todo maybe
      limited,
      minute,
      popular,
      price,
      timeUnit,
      translations,

      previewImage,
    } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-6">
            <div className="form-group">
              <label>Code</label>
              <input
                className="form-control form-control-sm"
                type="text"
                value={code}
                name="code"
                onChange={this.handleChangeForm}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <label>Price</label>
              <input
                className="form-control form-control-sm"
                type="number"
                min={0}
                value={price}
                onChange={ev => this.setState({
                  price: +ev.target.value
                })}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="form-group">
              <label>Duration</label>
              <input
                className="form-control form-control-sm"
                type="number"
                min={0}
                value={duration}
                onChange={ev => this.setState({
                  duration: +ev.target.value
                })}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="form-group">
              <label>Minute</label>
              <input
                className="form-control form-control-sm"
                type="number"
                min={0}
                value={minute}
                onChange={ev => this.setState({
                  minute: +ev.target.value
                })}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="form-group">
              <label>Time Unit</label>
              <select
                className="form-control form-control-sm"
                value={timeUnit}
                onChange={ev => this.setState({
                  timeUnit: ev.target.value
                })}
              >
                {unitsOfMeasurement.map(item => (
                  <option key={item} value={item}>{item}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="col-4">
            <div className="form-group">
              <label>Active</label>
              <select
                className="form-control form-control-sm"
                onChange={ev => this.setState({
                  active: Boolean(+ev.target.value)
                })}
                value={active ? "1" : "0"}
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="form-group">
              <label>Limited</label>
              <select
                className="form-control form-control-sm"
                onChange={ev => this.setState({
                  limited: Boolean(+ev.target.value)
                })}
                value={limited ? "1" : "0"}
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="form-group">
              <label>Popular</label>
              <select
                className="form-control form-control-sm"
                onChange={ev => this.setState({
                  popular: Boolean(+ev.target.value)
                })}
                value={popular ? "1" : "0"}
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>

          <div className="col-12">
            <Translations
              translations={translations}
              onChange={this.handleChangeLanguage}
            />
          </div>

          <div className="col-12">
            <label>Image</label>
            <input
              className="form-control"
              accept="image/*"
              type="file"
              name="image"
              placeholder="Upload Image"
              onChange={this.handleChangeImage}
            />
            {previewImage && (
              <div className="mb-3 text-center">
                <img
                  src={previewImage}
                  alt="Preview"
                  className="img-thumbnail"
                  style={{
                    maxWidth: "100%",
                    width: "auto",
                    marginTop: 20
                  }}
                />
              </div>
            )}
          </div>
        </div>

        <div className="text-right mt-2">
          <button
            className="btn btn-danger mr-2"
            onClick={this.props.onCancel}
          >
            Cancel
          </button>
          <button
            className="btn btn-success"
            onClick={this.handleSubmit}
          >
            Save
          </button>
        </div>
      </div>
    );
  }
}

EditModal.propTypes = {
  pack: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  unitsOfMeasurement: state.package.unitsOfMeasurement,
  packageImage: state.package.packageImage,
});

const mapStateToDispatch = dispatch => ({
  packageGetUnitsOfMeasurement: bindActionCreators(packageGetUnitsOfMeasurement, dispatch),
  packageGetImage: bindActionCreators(packageGetImage, dispatch),
  packageAddImage: bindActionCreators(packageAddImage, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(EditModal);



// WEBPACK FOOTER //
// ./src/views/pages/package/edit-modal.js